import { render } from "./EditCharacter.vue?vue&type=template&id=4853de17"
import script from "./EditCharacter.vue?vue&type=script&lang=js"
export * from "./EditCharacter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__